<template>
  <div v-if="gm" class="tip-radar">
    <div class="dyn-radar-head">
      <h3>Stat Share</h3>
      <span class="dyn-radar-sub">Match dominance, axis by axis</span>
    </div>
    <apexchart
      v-if="ready"
      type="radar"
      height="320"
      :options="radarOptions"
      :series="radarSeries"
    />
  </div>
</template>

<script>
export default {
  props: ["gameMoment", "homeTeam", "awayTeam"],
  data() {
    return { ready: false };
  },
  computed: {
    gm() {
      const m = this.gameMoment || {};
      return {
        homeTeam: m.homeTeam || this.homeTeam || "Home",
        awayTeam: m.awayTeam || this.awayTeam || "Away",
        homePossession: m.homePossession || 50,
        awayPossession: m.awayPossession || 50,
        homeOnTarget: m.homeOnTarget || 0,
        awayOnTarget: m.awayOnTarget || 0,
        homeDangerousAttacks: m.homeDangerousAttacks || 0,
        awayDangerousAttacks: m.awayDangerousAttacks || 0,
        homeAttacks: m.homeAttacks || 0,
        awayAttacks: m.awayAttacks || 0,
        homeCorners: m.homeCorners || 0,
        awayCorners: m.awayCorners || 0,
        homeYellowCards: m.homeYellowCards || 0,
        awayYellowCards: m.awayYellowCards || 0,
        homeRedCards: m.homeRedCards || 0,
        awayRedCards: m.awayRedCards || 0,
      };
    },
    radarSeries() {
      const g = this.gm;
      const norm = (a, b) => {
        const total = a + b;
        if (total <= 0) return [0, 0];
        return [Math.round((a / total) * 100), Math.round((b / total) * 100)];
      };
      const pos = [g.homePossession, g.awayPossession];
      const sot = norm(g.homeOnTarget, g.awayOnTarget);
      const da = norm(g.homeDangerousAttacks, g.awayDangerousAttacks);
      const att = norm(g.homeAttacks, g.awayAttacks);
      const cor = norm(g.homeCorners, g.awayCorners);
      const cards = norm(g.homeYellowCards + g.homeRedCards, g.awayYellowCards + g.awayRedCards);
      return [
        { name: this.gm.homeTeam, data: [pos[0], sot[0], da[0], att[0], cor[0], cards[0]] },
        { name: this.gm.awayTeam, data: [pos[1], sot[1], da[1], att[1], cor[1], cards[1]] },
      ];
    },
    radarOptions() {
      return {
        chart: {
          type: "radar",
          toolbar: { show: false },
          animations: { enabled: true, speed: 700, easing: "easeOutCubic" },
        },
        colors: ["#407BFF", "#FFCF75"],
        stroke: { width: 2 },
        fill: { opacity: 0.4 },
        markers: { size: 4, hover: { size: 7 } },
        xaxis: {
          categories: ["Possession", "SOT", "Dang. Atk", "Attacks", "Corners", "Cards"],
          labels: {
            style: {
              fontSize: "11px",
              colors: ["#fff", "#fff", "#fff", "#fff", "#fff", "#fff"],
              fontWeight: 600,
            },
          },
        },
        yaxis: { show: false, min: 0, max: 100 },
        legend: { position: "bottom", labels: { colors: "#fff" }, fontSize: "12px" },
        plotOptions: {
          radar: {
            polygons: {
              strokeColors: "rgba(255,255,255,0.25)",
              connectorColors: "rgba(255,255,255,0.15)",
            },
          },
        },
        tooltip: { theme: "dark", y: { formatter: (v) => v + "% share" } },
      };
    },
  },
  mounted() {
    setTimeout(() => { this.ready = true; }, 50);
  },
};
</script>

<style scoped lang="scss">
.tip-radar {
  background: linear-gradient(135deg, #07255B 0%, #1d3a8a 100%);
  border-radius: 24px;
  padding: 20px;
  color: #ffffff;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.2);
  margin-top: 24px;
}
.dyn-radar-head {
  margin-bottom: 6px;
  padding: 0 4px;
}
.dyn-radar-head h3 {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  color: #fff;
}
.dyn-radar-sub {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  opacity: 0.6;
  font-weight: 600;
}
</style>
